<template src="./ClientManagement.html"></template>
<script>
import CommandCell from "@/components/ClientCommandCellTemplate";
export default {
    data: function() {
    return {
      gridData: [],
      skip: 0,
      take: 10,
      pageSize: 10,
      userId: null,
      pageable: {
        pageSizes: true,
        previousNext: true
      },
      add: true,
      search: "",
      sort: [{ field: "name", dir: "asc" }],
      columns: [
        // { field: "id", title: "ID" },
        { field: "name", title: "Name" },
        { field: "contactPerson", title: "Contact Person" },
        { field: "contactNo", title: "Contact No" },
        { cell: CommandCell, title: "Actions", width: "200px" }
      ],
      dataItems: [],
      index: null,
      items: this.$store.state.clients.slice(this.skip, this.take+this.skip),
    };
  },
  methods: {
    searchEnterClicked(event) {
      let gridData = this.$store.state.clients;
      if(event.value) {
      this.items = gridData.filter(item =>item.name.toLowerCase().includes(event.value.toLowerCase()));
      } else {
      this.items = gridData;
      }
    },
    openWindow: function() {
      this.$router.push({
        name: "AddClient",
        params: { add: true }
      });
    },
    // exportExcel() {
    //   saveExcel({
    //     data: this.clientList,
    //     fileName: "Clients",
    //     columns: [
    //       { field: "id", title: "ID" },
    //       { field: "name", title: "Name" },
    //     ]
    //   });
    // },
    async getDataOnload() {
      this.$store.dispatch("loadClients").then(() => {
        this.items = this.$store.state.clients;
      });
    },
    edit: function(item) {
      return this.$store.dispatch("user/editClient", item.dataItem);
    },
    // remove: function(item) {
    //   return this.$store.dispatch("user/removeUser", item.dataItem).then(() => {
    //     // notify(MESSAGES.CHANGES_SAVE_SUCCESS);
    //   });
    //   // .catch(notifyApiError);
    // },
    pageChangeHandler: function(event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
    },
    sortChangeHandler: function(e) {
      this.sort = e.sort;
    }
  },
  computed: {
    // getClients(){
    //     return this.$store.state.clients;
    // },
    total() {
      return this.$store.state.clients ? this.$store.state.clients.length : 0;
    },
    // items() {
    //   return this.$store.state.clients;
    // },
    // filter() {
    //   return {
    //     logic: "or",
    //     filters: [
    //       { field: "userName", operator: "contains", value: this.search },
    //       { field: "phoneNumber ", operator: "contains", value: this.search }
    //     ]
    //   };
    // }
  },

  created: function() {
    this.getDataOnload();
  }
}
</script>